import { render, staticRenderFns } from "./handwritten-signature.vue?vue&type=template&id=30cc069f&scoped=true&"
import script from "./handwritten-signature.vue?vue&type=script&lang=js&"
export * from "./handwritten-signature.vue?vue&type=script&lang=js&"
import style0 from "./handwritten-signature.vue?vue&type=style&index=0&id=30cc069f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc069f",
  null
  
)

export default component.exports